import { Button, Heading, HFlow, Text, Tooltip, VFlow } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { Box } from 'components/Box'
import { DateTime } from 'components/date'
import { Age } from 'components/date/Age'
import { Cpf, Telefone } from 'components/label'
import { useHistory, useLocation, useRouteMatch } from 'react-router'
import { sexoRecord } from 'types/enums'
import Permissions from 'types/Permissions'

import { CidadaoCadsusItemType } from '../../create/cadsus/types/model-cadsus'

interface CidadaoCadsusListingItemProps {
  data: CidadaoCadsusItemType
}

export const CidadaoCadsusListingItem = (props: CidadaoCadsusListingItemProps) => {
  const { data } = props
  const telefone = data.telefoneCelular?.[0] || data.telefoneResidencial?.[0] || null

  const match = useRouteMatch()
  const location = useLocation()
  const history = useHistory()

  const isCidadaoJaCadastrado = !!data.cpfOuCnsJaCadastradoBaseLocal

  const handleOnBaseLocalClicked = () => {
    sessionStorage.setItem('cidadaoCadsus', JSON.stringify(props.data))
    history.push(`${match.url}/create${location.search}`)
  }

  return (
    <Box style={{ textAlign: 'left' }}>
      <HFlow justifyContent='space-between'>
        <VFlow vSpacing={0}>
          <Heading level={3}>{data.nome.titleCase()}</Heading>
          <HFlow hSpacing={4.5}>
            <VFlow vSpacing={0} style={{ width: 350 }}>
              <HFlow>
                <HFlow alignItems='center' hSpacing={0.5}>
                  <Text fontWeight='bold'>CPF</Text>
                  {data.cpf ? <Cpf value={data.cpf} /> : '-'}
                </HFlow>
                <HFlow alignItems='center' hSpacing={0.5}>
                  <Text fontWeight='bold'>CNS</Text>
                  {data.cns ? <Text>{data.cns}</Text> : '-'}
                </HFlow>
              </HFlow>
              <HFlow alignItems='center' hSpacing={0.5}>
                <Text fontWeight='bold'>Data de nascimento</Text>
                <DateTime format='DD/MM/YYYY' value={data.dataNascimento} />
                <Age dateOfBirth={data.dataNascimento} />
              </HFlow>
              <HFlow hSpacing={0.5}>
                <Text fontWeight='bold'>Sexo</Text>
                <Text>{sexoRecord[data.sexo]}</Text>
              </HFlow>
            </VFlow>
            <VFlow vSpacing={0}>
              <HFlow hSpacing={0.5}>
                <Text fontWeight='bold'>Nome da mãe</Text>
                <Text>{data.nomeMae.titleCase()}</Text>
              </HFlow>
              <HFlow alignItems='center' hSpacing={0.5}>
                <Text fontWeight='bold'>Telefone</Text>
                {telefone ? <Telefone value={telefone} /> : <Text>-</Text>}
              </HFlow>
              <HFlow hSpacing={0.5}>
                <Text fontWeight='bold'>Município de nascimento</Text>
                <Text>
                  {data?.municipioNascimento?.nome
                    ? data?.municipioNascimento?.nome.titleCase() + ' - ' + data?.municipioNascimento?.uf?.sigla
                    : '-'}
                </Text>
              </HFlow>
            </VFlow>
          </HFlow>
        </VFlow>
        <CheckPermission
          permission={Permissions.gestaoDeCadastrosIndividuais.visualizarCadastroIndividual.cadastrarEEditar}
        >
          <HFlow alignItems='center' hSpacing={0.5}>
            <Tooltip text={isCidadaoJaCadastrado ? 'CPF ou CNS já cadastrado na base local.' : null}>
              <Button
                kind='normal'
                skin='outline'
                size='small'
                disabled={isCidadaoJaCadastrado}
                onClick={handleOnBaseLocalClicked}
              >
                Cadastrar na base local
              </Button>
            </Tooltip>
          </HFlow>
        </CheckPermission>
      </HFlow>
    </Box>
  )
}
